module.exports = __webpack_public_path__ + "static/media/hiw1.d392ddd6.svg";